<app-header></app-header>
<div class="body-container clearfix">
    <div class="row decision-model-title-container">
        <h1 class="decision-title font-mont-regular">
            Select your vendor to impersonate
        </h1>
    </div>
    <div *ngIf="selectedVendor.name" class="row selected-options">
        <div class="col-12">
            <h4 class="selected-vendor">
                <span>{{selectedVendor.name}} ({{selectedVendor.id}})</span>
                <span>, {{selectedVendor.defaultSalesPerson}} ({{selectedVendor.defaultSalesPersonId}})</span>
                <button class="btn btn-secondary font-mont-regular" type="submit" id="createNewDecisionModelOpenDlgBtn">
                    <div class="tooltip-two">
                        <div class="plus-area" (click)="onCloseVendorClick();">
                            <i class="fas fa-times"></i>
                        </div>
                        <span class="tooltip-two-text">
                            Click here to go back and select vendor.
                        </span>
                    </div>
                </button>
            </h4>
        </div>
    </div>
    <form>
        <div class="row">
            <div class="form-group col-12">
                <input type="text" class="form-control" id="vendorName" placeholder="Search Vendor Name"
                    [formControl]="vendorName" name="vendorName" (keyup)="onVendorNameKeyUp(0, 8)">
            </div>
        </div>
    </form>
    <div class="row table-container">
        <div class="col-12">
            <table class="table">
                <thead>
                    <tr>
                        <th class="font-mont-semi-bold" scope="col">Id</th>
                        <th class="text-right font-mont-semi-bold" scope="col">Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let vendor of vendorData.records" (click)="onVendorClick(vendor);"
                        [ngClass]="{'table-primary': vendor.id == selectedVendor.id, 'row-disabled': vendor.defaultSalesPersonId == null}">
                        <td scope="row"> {{vendor.id}} </td>
                        <td class="text-right"> {{vendor.name}} </td>
                    </tr>
                </tbody>
            </table>
            <nav aria-label="Page navigation example" *ngIf="vTotalPages > 1">
                <ul class="pagination justify-content-end">
                    <li class="page-item" [ngClass]="{'disabled': vSliceNumber == 0}" (click)="onVBackClick();">
                        <a class="page-link" tabindex="-1">Previous</a>
                    </li>
                    <li class="page-item" *ngFor="let slice of vSlices"
                        [ngClass]="{'active': vSliceNumber + 1 == slice}" (click)="onVSliceClick(slice - 1);">
                        <a class="page-link"
                            *ngIf="slice - 1 > vSliceNumber - 5 && vSliceNumber + 5 > slice - 1">{{slice}}</a>
                    </li>
                    <li class="page-item" [ngClass]="{'disabled': vSliceNumber == vTotalPages - 1}"
                        (click)="onVNextClick();">
                        <a class="page-link">Next</a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
    <div *ngIf="selectedVendor.name" class="row">
        <div class="col-12">
            <button class="btn btn-primary float-right" type="submit" data-toggle="modal" (click)="onContinueClick();"
                id="create-attribute-button">
                Continue
            </button>
        </div>
    </div>
</div>